<template>
  <v-container width="100%" style="background: #f5f5f5">
    <div id="header" class="mt-3 px-3">
      <h2>{{ $t('Informações do equipamento') }}</h2>
      <div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              color="#e8e8e8"
              dark
              depressed
              @click="generatePDF(currentEquipment)"
              v-bind="attrs"
              v-on="on"
              small
            >
              <v-icon small color="#0F3565"> mdi-printer </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Imprimir') }}</span>
        </v-tooltip>
      </div>
    </div>

    <v-divider class="my-3"></v-divider>

    <v-row
      class="ma-0 px-5"
      v-if="currentEquipment.alienated"
      style="color: #df4759"
    >
      <v-col class="py-0" cols="12">
        <h3>{{ $t('Equipamento Alienado') }}</h3>
      </v-col>
      <v-col class="pb-0" cols="12" sm="4" md="4" lg="4">
        <strong>Data:</strong>
        {{ formatDate(currentEquipment.alienationDate) }}
      </v-col>
      <v-col class="pb-0" cols="12" sm="8" md="8" lg="8">
        <strong>Motivo:</strong>
        {{ currentEquipment.alienationMotive }}
      </v-col>
    </v-row>

    <v-divider v-if="currentEquipment.alienated" class="my-3"></v-divider>

    <v-row dense class="ma-0 px-5">
      <v-col class="py-0" cols="12" sm="6" md="6" lg="6">
        <span>
          <strong>{{ $t('MTBF Equipamento') }}:</strong>
          {{ `${mtbf} ${$t('dias')}` }}
        </span>
      </v-col>
      <v-col class="py-0" cols="12" sm="6" md="6" lg="6">
        <span>
          <strong>{{ $t('Data de cadastro') }}:</strong>
          {{ formatDate(currentEquipment.create) }}
        </span>
      </v-col>
    </v-row>

    <v-divider class="my-3"></v-divider>

    <v-row dense class="ma-0 px-5 py-0">
      <v-col cols="12">
        <h3>{{ $t('Dados gerais') }}</h3>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Identificação') }}:</strong>
          {{ currentEquipment.identification }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Instituição') }}:</strong>
          {{ currentEquipment.institution.name }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Unidade') }}:</strong>
          {{ currentEquipment.unidade.name }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Equip. Padrão') }}:</strong>
          {{ currentEquipment.standardEquipment.name }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Equipamento') }}:</strong>
          {{
            currentEquipment.name != '' ? currentEquipment.name : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Setor') }}:</strong>
          {{ currentEquipment.department.name }}
        </p>
      </v-col>
      <v-col
        class="py-0"
        cols="12"
        sm="4"
        md="4"
        lg="4"
        v-if="currentEquipment.subDepartment"
      >
        <p>
          <strong class="field">Sub-setor:</strong>
          {{ currentEquipment.subDepartment.name }}
        </p>
      </v-col>

      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Cód Patrimônio') }}:</strong>
          {{
            currentEquipment.propertyCode != ''
              ? currentEquipment.propertyCode
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Fabricante') }}:</strong>
          {{
            currentEquipment.manufacturer != ''
              ? currentEquipment.manufacturer
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Localização') }}:</strong>
          {{
            currentEquipment.location != ''
              ? currentEquipment.location
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Modelo') }}:</strong>
          {{
            currentEquipment.model != ''
              ? currentEquipment.model
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Nº Série') }}:</strong>
          {{
            currentEquipment.serialNumber != ''
              ? currentEquipment.serialNumber
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Nº Anvisa') }}:</strong>
          {{
            currentEquipment.numberAnvisa != ''
              ? currentEquipment.numberAnvisa
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="2" md="2" lg="2">
        <p class="mb-0">
          <strong class="field">{{ $t('Tensão') }}:</strong>
          {{
            currentEquipment.voltage != -1
              ? voltages[currentEquipment.voltage]
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="2" md="2" lg="2">
        <p class="mb-0">
          <strong class="field">{{ $t('Potência') }}:</strong>
          {{
            currentEquipment.candlePower != ''
              ? `${currentEquipment.candlePower} W`
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p class="mb-0">
          <strong class="field">{{ $t('Contrato') }}:</strong>
          {{
            currentEquipment.contract != null
              ? currentEquipment.contract.name
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p class="mb-0">
          <strong class="field">{{ $t('Valor contrato') }}:</strong>
          {{
            currentEquipment.contractValue != 0
              ? `${currentEquipment.contractValue.toInstLocale()}`
              : 'Sem registro'
          }}
        </p>
      </v-col>
    </v-row>

    <v-divider class="my-3"></v-divider>

    <v-row class="ma-0 px-5" dense>
      <v-col class="pt-0" cols="12">
        <h3>{{ $t('Criticidade') }}</h3>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p class="mb-0">
          <strong class="field">{{ $t('Função') }}:</strong>
          {{
            functionsEquipment[
              currentEquipment.standardEquipment.functionEquipment
            ]
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p class="mb-0">
          <strong class="field">{{ $t('Risco') }}:</strong>
          {{ equipmentRisks[currentEquipment.standardEquipment.equipmentRisk] }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="1" md="1" lg="1">
        <p class="mb-0">
          <strong class="field">{{ $t('Grau') }}:</strong>
          {{
            currentEquipment.degreeImportance != ''
              ? currentEquipment.degreeImportance
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="1" md="1" lg="1">
        <p class="mb-0">
          <strong class="field">{{ $t('Valor') }}:</strong>
          {{
            currentEquipment.criticality != ''
              ? currentEquipment.criticality
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0">
        <p class="mb-0">
          <strong class="field">{{ $t('Criticidade') }}:</strong>
          {{ getCriticalityLevel() }}
        </p>
      </v-col>
    </v-row>

    <v-divider class="my-3"></v-divider>

    <v-row class="ma-0 px-5" dense>
      <v-col class="pt-0" cols="12">
        <h3>{{ $t('Manutenção') }}</h3>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p class="mb-0">
          <strong class="field">{{ $t('Custo com manutenção') }}:</strong>
          {{ maintenanceCost.toInstLocale() }}
        </p>
      </v-col>
    </v-row>

    <v-divider class="my-3"></v-divider>

    <v-row class="ma-0 px-5" dense>
      <v-col class="pt-0" cols="12">
        <h3>{{ $t('Aquisição') }}</h3>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Fornecedor') }}:</strong>
          {{
            currentEquipment.supplier != null
              ? currentEquipment.supplier.name
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Valor compra') }}:</strong>
          {{
            currentEquipment.purchasePrice != 0
              ? ` ${currentEquipment.purchasePrice.toInstLocale()} `
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Câmbio do dia') }}:</strong>
          {{
            currentEquipment.exchangeDay != 0
              ? ` ${currentEquipment.exchangeDay.toInstLocale()}`
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Situação') }}:</strong>
          {{ situations[currentEquipment.equipmentAcquisitionSituation] }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Data compra') }}:</strong>
          {{
            currentEquipment.purchaseDate != null
              ? formatDate(currentEquipment.purchaseDate)
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Data entrega') }}:</strong>
          {{
            currentEquipment.deliveryDate != null
              ? formatDate(currentEquipment.deliveryDate)
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p class="mb-0">
          <strong class="field">{{ $t('Tempo garantia') }}:</strong>
          {{
            currentEquipment.warrantyTime != null
              ? `${currentEquipment.warrantyTime} meses`
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p class="mb-0">
          <strong class="field">{{ $t('Início garantia') }}:</strong>
          {{
            currentEquipment.warrantyStartDate != null
              ? formatDate(currentEquipment.warrantyStartDate)
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p class="mb-0">
          <strong class="field">{{ $t('Término garantia') }}:</strong>
          {{
            currentEquipment.warrantyEndDate != null
              ? formatDate(currentEquipment.warrantyEndDate)
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p class="mb-0">
          <strong class="field">Nota fiscal:</strong>
          {{
            currentEquipment.invoice != ''
              ? currentEquipment.invoice
              : 'Sem registro'
          }}
        </p>
      </v-col>
    </v-row>

    <v-divider class="my-3"></v-divider>

    <v-row class="ma-0 px-5" dense>
      <v-col class="pt-0" cols="12">
        <h3>{{ $t('Depreciação') }}</h3>
      </v-col>
      <v-col class="py-0" cols="12" sm="3">
        <p>
          <strong class="field">{{ $t('Estado de conservação') }}:</strong>
          {{ conservationStates[currentEquipment.conservationState] }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3">
        <p>
          <strong class="field">{{ $t('Fator fim de vida') }}:</strong>
          {{
            currentEquipment.endLifeFactor != null
              ? endLifeFactors[currentEquipment.endLifeFactor]
              : 'ATUAL'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3">
        <p>
          <strong class="field">{{ $t('Fator tecnologia') }}:</strong>
          {{ technologyFactors[currentEquipment.technologyFactor] }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3">
        <p>
          <strong class="field">{{ $t('Valor de mercado') }}:</strong>
          {{
            currentEquipment.marketValue
              ? currentEquipment.marketValue.toInstLocale()
              : '00,00'
          }}
        </p>
      </v-col>

      <v-col class="py-0" cols="12" sm="3">
        <p>
          <strong class="field">{{ $t('Valor Depreciado Contábil') }}:</strong>
          {{ depreciatedValue ? depreciatedValue.toInstLocale() : '00,00' }}
        </p>
      </v-col>
    </v-row>

    <v-divider class="my-3"></v-divider>

    <v-row class="px-5 ma-0" dense>
      <v-col class="pt-0" cols="12">
        <h3>{{ $t('Informações complementares') }}</h3>
      </v-col>
      <v-col class="py-0" cols="12">
        <p>
          <strong class="field">{{ $t('Manuais que acompanham') }}:</strong>
          {{
            currentEquipment.manuals != ''
              ? currentEquipment.manuals
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12">
        <p>
          <strong class="field">{{ $t('Acessórios e insumos') }}:</strong>
          {{
            currentEquipment.accessories != ''
              ? currentEquipment.accessories
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12">
        <p>
          <strong class="field">{{ $t('Observações') }}:</strong>
          {{
            currentEquipment.observation != ''
              ? currentEquipment.observation
              : 'Sem registro'
          }}
        </p>
      </v-col>
    </v-row>

    <v-tabs background-color="#f5f5f5" v-model="tab" color="secondary">
      <v-tab active-class="activated-tab" class="rounded-lg rounded-b-0">{{
        $t('O.S.')
      }}</v-tab>
      <!-- <v-tab>{{ $t('Migrações de setor') }}</v-tab> -->
      <v-tab active-class="activated-tab" class="rounded-lg rounded-b-0">{{
        $t('Migrações')
      }}</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-data-table
          :headers="headersServiceOrder"
          :items="serviceOrders"
          class="main-table row-pointer"
          hide-default-footer
          hide-default-header
          :items-per-page="serviceOrders.length"
          :loading="loading"
          disable-pagination
          @click:row="openServiceOrder"
        >
          <template #header="{ props, on }">
            <thead>
              <tr>
                <th
                  class="text-center"
                  v-for="header in props.headers"
                  :key="header.value"
                >
                  <v-simple-checkbox
                    v-if="header.value === 'data-table-select'"
                    v-model="props.everyItem"
                    :indeterminate="props.someItems && !props.everyItem"
                    color="purple"
                    @input="on['toggle-select-all']"
                  ></v-simple-checkbox>

                  <div>
                    <v-hover v-slot="{ hover }">
                      <div>
                        <span>{{ $t(header.text) }}</span>
                        <v-icon
                          v-if="
                            hover &&
                            header.value != 'data-table-select' &&
                            header.value != 'actions'
                          "
                          color="white"
                          class="mx-2"
                          @click="on.sort(header.value)"
                        >
                          {{
                            props.options.sortBy.includes(header.value)
                              ? `mdi-chevron-down`
                              : `mdi-chevron-up`
                          }}
                        </v-icon>
                      </div>
                    </v-hover>
                  </div>
                </th>
              </tr>
            </thead>
          </template>

          <template #[`item.name`]="{ item }">
            {{ item.name }}
          </template>
          <template #[`item.type`]="{ item }">
            {{ serviceOrderTypes[item.serviceOrderType] }}
          </template>
          <template #[`item.requestDate`]="{ item }">
            {{ formatDateTime(item.dateTimeRequest) }}
          </template>
          <template #[`item.closeDate`]="{ item }">
            {{
              item.closeServiceOrderDateTime != null
                ? formatDateTime(item.closeServiceOrderDateTime)
                : 'Sem registro'
            }}
          </template>
        </v-data-table>
      </v-tab-item>

      <v-tab-item>
        <v-data-table
          :headers="migrationInstHeaders"
          :items="institutionMigrations"
          class="main-table row-pointer"
          hide-default-footer
          hide-default-header
          :items-per-page="institutionMigrations.length"
          :loading="loading"
          disable-pagination
        >
          <template #header="{ props, on }">
            <thead>
              <tr>
                <th
                  class="text-center"
                  v-for="header in props.headers"
                  :key="header.value"
                >
                  <v-simple-checkbox
                    v-if="header.value === 'data-table-select'"
                    v-model="props.everyItem"
                    :indeterminate="props.someItems && !props.everyItem"
                    color="purple"
                    @input="on['toggle-select-all']"
                  ></v-simple-checkbox>

                  <div>
                    <v-hover v-slot="{ hover }">
                      <div>
                        <span>{{ $t(header.text) }}</span>
                        <v-icon
                          v-if="
                            hover &&
                            header.value != 'data-table-select' &&
                            header.value != 'actions'
                          "
                          color="white"
                          class="mx-2"
                          @click="on.sort(header.value)"
                        >
                          {{
                            props.options.sortBy.includes(header.value)
                              ? `mdi-chevron-down`
                              : `mdi-chevron-up`
                          }}
                        </v-icon>
                      </div>
                    </v-hover>
                  </div>
                </th>
              </tr>
            </thead>
          </template>

          <template #[`item.date`]="{ item }">
            {{ formatDateTime(item.date) }}
          </template>
          <template #[`item.reason`]="{ item }">
            {{ item.reason ? item.reason : $t('Sem registros') }}
          </template>
          <template #[`item.lastUnit.name`]="{ item }">
            {{
              item.lastUnit && item.lastUnit.name
                ? item.lastUnit.name
                : 'Sem registro'
            }}
          </template>
          <template #[`item.unit.name`]="{ item }">
            {{ item.unit && item.unit.name ? item.unit.name : 'Sem registro' }}
          </template>
          <template #[`item.lastDepartment.name`]="{ item }">
            {{
              item.lastDepartment && item.lastDepartment.name
                ? item.lastDepartment.name
                : 'Sem registro'
            }}
          </template>
          <template #[`item.department.name`]="{ item }">
            {{
              item.department && item.department.name
                ? item.department.name
                : 'Sem registro'
            }}
          </template>
          <template #[`item.lastSubDepartment.name`]="{ item }">
            {{
              item.lastSubDepartment && item.lastSubDepartment.name
                ? item.lastSubDepartment.name
                : 'Sem registro'
            }}
          </template>
          <template #[`item.subDepartment.name`]="{ item }">
            {{
              item.subDepartment && item.subDepartment.name
                ? item.subDepartment.name
                : 'Sem registro'
            }}
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<style scoped>
#header {
  display: flex;
  justify-content: space-between;
}
.field {
  display: block;
}
</style>

<script>
import ApiService from '../../../../services/ApiService'
import utils from '../../../../Utils/FormatDate'
import moment from 'moment'

export default {
  props: {
    receivedEquipment: {
      type: Object,
      required: true,
    },
  },

  async created() {
    this.userType = JSON.parse(localStorage.getItem('institution')).userType

    this.currentEquipment = this.receivedEquipment

    console.log(this.currentEquipment)

    this.getMtbf()
    const dialog = document.getElementsByClassName('v-dialog--active')[0]
    if (dialog) {
      dialog.scrollTop = 0
    }

    Promise.all([
      await this.listServicesOrders(),
      await this.getMigrations(),
      this.calculateCriticality(),
      await this.getInstMigrations(),
      await this.getMaintenanceCost(),
    ])
  },

  data: () => ({
    maintenanceCost: 0,
    migrations: [],
    migrationInstHeaders: [
      {
        text: '',
        align: 'center',
        value: '',
        sortable: false,
      },
      {
        text: 'Instituição origem',
        align: 'center',
        value: 'lastInstitution.name',
        sortable: false,
      },
      {
        text: 'Instituição destino',
        align: 'center',
        value: 'institution.name',
        sortable: false,
      },
      {
        text: 'Unidade origem',
        align: 'center',
        value: 'lastUnit.name',
        sortable: false,
      },
      {
        text: 'Unidade destino',
        align: 'center',
        value: 'unit.name',
        sortable: false,
      },
      {
        text: 'Setor origem',
        align: 'center',
        value: 'lastDepartment.name',
        sortable: false,
      },
      {
        text: 'Setor destino',
        align: 'center',
        value: 'department.name',
        sortable: false,
      },
      {
        text: 'Sub-setor origem',
        align: 'center',
        value: 'lastSubDepartment.name',
        sortable: false,
      },
      {
        text: 'Sub-Setor destino',
        align: 'center',
        value: 'subDepartment.name',
        sortable: false,
      },
      {
        text: 'Motivo',
        align: 'center',
        value: 'reason',
        sortable: false,
      },
      {
        text: 'Data',
        align: 'center',
        value: 'date',
        sortable: false,
      },
    ],
    migrationHeaders: [
      {
        text: '',
        align: 'center',
        value: '',
        sortable: false,
      },
      {
        text: 'Unidade/Setor Origem',
        align: 'center',
        value: 'departmentSourceName',
        sortable: false,
      },
      {
        text: 'Unidade/Setor Destino',
        align: 'center',
        value: 'departmentDestinyName',
        sortable: false,
      },
      {
        text: 'Data da migração',
        align: 'center',
        value: 'dateFormated',
        sortable: false,
      },
      {
        text: 'Motivo',
        align: 'center',
        value: 'reason',
        sortable: false,
      },
    ],
    tab: 0,
    conservationStates: ['Bom', 'Ruim', 'Péssimo'],
    endLifeFactors: ['End of Life', 'End of Service'],
    technologyFactors: ['Atual', 'Defasagem Mínima', 'Defasado'],
    serviceOrders: [],
    loading: false,
    serviceOrderTypes: [
      'Treinamento',
      'Segurança elétrica',
      'Preventiva',
      'Instalação',
      'Rotina de Inspeção',
      'Corretiva',
      'Calibração',
      'Validação/Qualificação',
      'Serviço Administrativo',
      'Empréstimo',
    ],

    headersServiceOrder: [
      {
        text: '',
        align: 'center',
        value: '',
        sortable: false,
      },
      {
        text: 'Num. OS',
        align: 'center',
        value: 'number',
        sortable: false,
      },
      {
        text: 'Nome',
        align: 'center',

        value: 'name',
      },
      {
        text: 'Tipo',
        align: 'center',

        value: 'type',
      },
      {
        text: 'Data Agendamento',
        align: 'center',

        value: 'requestDate',
      },
      {
        text: 'Data Fechamento',
        align: 'center',

        value: 'closeDate',
      },
    ],

    unidades: [],
    standardEquipment: [],
    currentStandardEquipment: {},
    departments: [],
    contracts: [],
    suppliers: [],
    unidadeName: '',
    departmentName: '',
    contractName: '',
    supplierName: '',
    mtbf: 0,
    userType: null,
    situations: [
      'Aluguel',
      'Comodato',
      'De médico/Equipe',
      'Empréstimo',
      'Próprio',
      'Terceiros',
    ],
    voltages: [
      '110V',
      '220V',
      '110V / 220V - Bivolt',
      '220V Trifásico',
      '380V Trifásico',
      '440V',
      '480V',
      '13,8KV',
    ],
    functionsEquipment: [
      'Acessório',
      'Análise',
      'Diagnóstico',
      'Outros equipamentos de apoio',
      'Suporte à vida',
      'Terapia',
    ],
    equipmentRisks: [
      'Acessório',
      'Injuria',
      'Morte',
      'Sem risco',
      'Terapia ou diagnóstico inapropriado',
    ],
    currentEquipment: {
      id: 0,
      standardEquipmentId: 0,
      departmentId: 0,
      contractId: 0,
      supplierId: 0,
      unidadeId: 0,
      name: '',
      propertyCode: '',
      manufacturer: '',
      location: '',
      model: '',
      serialNumber: '',
      voltage: -1,
      candlePower: '',
      identification: '',
      contractValue: '',
      numberAnvisa: '',
      purchasePrice: '',
      purchaseDate: null,
      equipmentAcquisitionSituation: -1,
      degreeImportance: -1,
      exchangeDay: '',
      warrantyTime: '',
      deliveryDate: null,
      warrantyStartDate: null,
      warrantEndDate: null,
      installationEndDate: null,
      manuals: '',
      accessories: '',
      observation: '',
      alienated: false,
      criticality: 0,
      lifeExpectancy: 0,
      invoice: '',
    },
    apiService: new ApiService(),
    institutionMigrations: [],
  }),

  computed: {
    depreciatedValue() {
      const date = this.currentEquipment.purchaseDate
        ? this.currentEquipment.purchaseDate
        : this.currentEquipment.create

      const years = moment(new Date()).diff(new Date(date), 'years', true)

      const tax = this.currentEquipment.lifeExpectancy
        ? 100 / this.currentEquipment.lifeExpectancy
        : 1

      const amountTax = tax * parseInt(years)

      const value = this.currentEquipment.purchasePrice
        ? this.currentEquipment.purchasePrice
        : this.currentEquipment.marketValue

      return (amountTax / 100) * value
    },
  },

  methods: {
    arquivo() {
      this.apiService.get('health/arquivos').then((rs) => {})
    },

    async getInstMigrations() {
      await this.apiService
        .get(`equipment/institution-migrations/${this.currentEquipment.id}`)
        .then((response) => {
          this.institutionMigrations = response.content
        })
    },

    calculateCriticality() {
      let functionScore = 0
      let riskScore = 0
      let indexAbcScore = 0

      switch (this.currentEquipment.standardEquipment.functionEquipment) {
        case 4:
          functionScore = 10
          break
        case 5:
          functionScore = 8
          break
        case 2:
          functionScore = 6
          break
        case 1:
          functionScore = 4
          break
        case 3:
          functionScore = 2
          break
        default:
          functionScore = 0
          break
      }

      switch (this.currentEquipment.standardEquipment.equipmentRisk) {
        case 2:
          riskScore = 7
          break
        case 1:
          riskScore = 5
          break
        case 4:
          riskScore = 3
          break
        case 3:
          riskScore = 1
          break
        default:
          riskScore = 0
          break
      }

      switch (this.currentEquipment.degreeImportance) {
        case 'A':
          indexAbcScore = 10
          break
        case 'B':
          indexAbcScore = 5
          break
        default:
          indexAbcScore = 0
          break
      }

      this.currentEquipment.criticality =
        functionScore + riskScore + indexAbcScore
    },

    async getMigrations() {
      await this.apiService
        .get(`equipment/getMigrations/${this.currentEquipment.id}`)
        .then((response) => {
          this.migrations = response.content.map((value) => {
            return {
              ...value,
              dateFormated: moment(value.migretionDate).format('DD/MM/YYYY'),
            }
          })
        })
    },

    async getMaintenanceCost() {
      await this.apiService
        .get(`equipment/maintenance-cost/${this.currentEquipment.id}`)
        .then((response) => {
          this.maintenanceCost = response.content
        })
    },

    async listServicesOrders() {
      await this.apiService
        .get(`serviceOrder/list/all/${this.currentEquipment.id}`)
        .then((response) => {
          this.serviceOrders = response.content
          this.showSchedule = response.content.length > 0
        })
    },

    openServiceOrder(serviceOrder) {
      const route = this.$router.resolve({
        path: `/editServiceOrder/${serviceOrder.id}`,
      })
      window.open(route.href, '_blank')
    },

    close() {
      this.$emit('close')
    },

    getCriticalityLevel() {
      if (
        this.currentEquipment.criticality >= 3 &&
        this.currentEquipment.criticality < 12
      ) {
        return 'Baixa'
      } else if (
        this.currentEquipment.criticality >= 12 &&
        this.currentEquipment.criticality < 19
      ) {
        return 'Média'
      } else if (this.currentEquipment.criticality >= 19) {
        return 'Alta'
      }
    },

    formatDateTime(date) {
      return utils.dateTime(date)
    },

    async getMtbf() {
      await this.apiService
        .get(`equipment/mtbf/${this.currentEquipment.id}`)
        .then((response) => {
          this.mtbf = response.content
        })
    },

    async getUnidade() {
      const unidadeId = this.currentEquipment.unidadeId

      if (unidadeId != null) {
        await this.apiService.get(`unidade/${unidadeId}`).then((response) => {
          this.unidadeName = response.content.name
        })
      }
    },

    async getStandardEquipment() {
      const standardEquipmentId = this.currentEquipment.standardEquipmentId

      if (standardEquipmentId != null) {
        await this.apiService
          .get(`standardEquipment/${standardEquipmentId}`)
          .then((response) => {
            this.currentStandardEquipment = response.content
          })
      }
    },

    async getDepartment() {
      const departmentId = this.currentEquipment.departmentId

      if (departmentId != null) {
        await this.apiService
          .get(`department/${departmentId}`)
          .then((response) => {
            this.departmentName = response.content.name
          })
      }
    },

    async getContract() {
      const contractId = this.currentEquipment.contractId

      if (contractId != null) {
        await this.apiService.get(`contract/${contractId}`).then((response) => {
          this.contractName = response.content.name
        })
      }
    },

    async getSupplier() {
      const supplierId = this.currentEquipment.supplierId

      if (supplierId != null) {
        await this.apiService.get(`supplier/${supplierId}`).then((response) => {
          this.supplierName = response.content.name
        })
      }
    },

    async generatePDF(equipment) {
      this.printDialog = true
      this.apiService
        .get(`equipment/printEquipment/${equipment.id}`)
        .then((response) => {
          var w = window.open('')
          w.document.write(response.content.html)

          var pedfResult = 'data:application/pdf;base64,' + response.content.pdf
          const link = document.createElement('a')
          link.href = pedfResult
          link.setAttribute(
            'download',
            `Equipamento:${equipment.id}_${this.formatDate(new Date())}`
          )
          document.body.appendChild(link)
          link.click()
          this.printDialog = false
        })
        .catch(() => {})
      this.$emit('show', 'Baixando PDF!')
    },

    formatDate(date) {
      return utils.moment(date)
    },
  },
}
</script>

<style></style>
